import { render, staticRenderFns } from "./ProSignUpPage.vue?vue&type=template&id=9cec00b6"
import script from "./ProSignUpPage.vue?vue&type=script&lang=js"
export * from "./ProSignUpPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports